export default "__VITE_ASSET__Dsu8nUR7__"